// Home hero object: the globe over a giant soft hairline "6".
export const HeroGlobe = ({ children }) => (
  <div data-testid="zone-diagram" className="relative aspect-square w-full">
    <svg aria-hidden viewBox="0 0 1000 1000" className="pointer-events-none absolute inset-0 h-full w-full overflow-visible">
      <text x="500" y="915" fill="#0B2E44" fillOpacity="0.06" stroke="#0B2E44" strokeOpacity="0.22" strokeWidth="1" fontSize="1180" fontFamily="Cormorant, serif" fontWeight="300" textAnchor="middle">6</text>
    </svg>
    <div className="absolute inset-[3%] z-[1]">{children}</div>
  </div>
);
